import React from "react";
import { Link } from "react-router-dom";
import copyrightsvg from "../icons/copyright-ico-white.svg";
import "./About.css";
import YasiruImg from "../images/Yasiru.png";
import aboutmeico from "../icons/aboutme-ico-white.svg";
import infoIco from "../icons/InfoCircle.svg";

const About = () => {
  return (
    <div className="about-me-div">
      <div className="about-me-container">
        <img src={YasiruImg} alt="me" />
        <div className="about-details">
          <div className="about-content-div">
            <div className="about-heading-div">
              <img src={infoIco} alt="info icon" />
              <div className="about-heading">Who I am?</div>
            </div>
            <div className="name-div">
              <img src={aboutmeico} alt="ghost-ico" />
              <div className="my-name">HI! I'M YASIRU PANDUKA</div>
            </div>
            <div className="tag-line">
              someone who loves creating and exploring different forms of art
              and technology
            </div>
            <div className="about-content">
              I'm someone who loves creating and exploring different forms of
              art and technology. From designing sleek interfaces to bringing
              game worlds to life, I'm always finding new ways to combine my
              skills and passion. <span>Whether it's a new illustration or coding a
              game, I enjoy every step of the creative process and constantly
              push myself to learn and grow.</span>
            </div>
          </div>
          <div className="about-content-div">
            <div className="about-content-heading">My Passion</div>
            <div className="about-content">
              What drives me is the excitement of turning imagination into
              reality. Whether it's crafting a stunning UI/UX design, developing
              a game from scratch, or illustrating bold and expressive
              characters, I thrive on the creative process. I believe in the
              power of design and technology to create meaningful experiences.
            </div>
          </div>
          <div className="about-content-div">
            <div className="about-content-heading">Skills & Expertise</div>
            <div className="about-content-points">
              <ul>
                <li>
                  <span>UI/UX Design:</span> Designing user-friendly and visually appealing
                  interfaces for mobile, web, and tablet platforms.
                </li>
                <li>
                  <span>3D Art & Animation:</span> Creating 3D models, environments, and
                  animations, bringing ideas to life in digital space.
                </li>
                <li>
                  <span>Game Development:</span> Developing indie games with a focus on
                  immersive environments and gameplay.
                </li>
                <li>
                  <span>Programming:</span> Skilled in front-end and back-end development for
                  websites and mobile applications, using technologies like
                  JavaScript, React, and MERN stack.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Make CopyRight component here due to another css */}
        <div className="copyright-div" id="copyright-div-me">
          <div className="about-heading-div">
            <img src={copyrightsvg} alt="copyright-icon" />
            <div className="about-heading">Copyright Notice</div>
          </div>

          <div className="copyright-content" id="copyright-content-me">
            All content, images, videos, and materials on this website are the
            property of Yasiru Panduka. Unauthorized use, reproduction, or
            distribution of any content without prior written permission is
            strictly prohibited and may be subject to legal action.
          </div>

          <div className="copyright-contact">
            <div className="copyright-contact-info">
              For inquiries or permission requests, please contact:
            </div>
            <div className="copyright-contact-mail">
              Email:{" "}
              <Link to="mailto: yasirupanduka.penta@gmail.com">
                yasirupanduka.penta@gmail.com
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
